import {useDispatch} from "react-redux";
import Modal from "../../../../Common/Modal";
import styles from './EditNote.module.scss';
import { Button } from '@mui/material';
import React, {useState, useEffect} from 'react';
import {clientActions} from "../../../store";
import { useTranslation } from 'react-i18next';

const EditNote = ({client_id, nota, isModalOpen, setIsModalOpen}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [editedNota, setEditedNota] = useState(nota?.nota);

    const handleNoteChange = (event) => {
        setEditedNota(event.target.value);
    };

    useEffect(() => {
        setEditedNota(nota?.nota);
    }, [nota]);
    return (
        <Modal
            // height={content ? '300px' : '230px'}
            isModalOpen={isModalOpen}
            setIsModalOpen={() => {
                setEditedNota("");
                setIsModalOpen(false)
            }}
            title={t('clients.clientModal.editNote.title')}
            maxWidth={'380px'}
            showCloseBtn={true}

        >
            <div className={styles.main}>
                <div className={styles.body}>
                    <div className={styles.description}>
                        <label>{t('clients.clientModal.editNote.descriptionLabel')}</label>
                        <textarea cols="30" rows="10" placeholder={t('clients.clientModal.editNote.textareaPlaceholder')} value={editedNota} onChange={handleNoteChange}></textarea>
                    </div>
                </div>
                <div className={styles.footer}>
                    <Button
                        variant='contained'
                        className={styles.confirm_button}
                        onClick={() => {
                            dispatch(
                                clientActions.EDIT_NOTE.REQUEST(
                                    {
                                        idnota: nota?.idutentenota,
                                        nota: editedNota
                                    },() => {
                                        dispatch(clientActions.GET_CLIENT.REQUEST({ idcliente: client_id }, () => setIsModalOpen(false)));
                                        setEditedNota("");
                                    }
                                ),
                            )
                        }}
                    >
                        {t('common.actions.save')}
                    </Button>
                </div>
            </div>
        </Modal>
    );
}

export default EditNote;
